export default "__VITE_ASSET__PZ3DSOHk__"